'use client'
import { getChannelClipsByUsername } from '@/app/util/channel-api'
import UAParserContext from '@/context/ua-parser'
import { IChannel, IGif } from '@giphy/js-types'
import { useCallback, useContext } from 'react'
import { desktopContent } from 'ui/src/constants'
import VideoGrid from '../../../../components/grid/video-grid'

const clientsideFetchLimit = 25

type Props = { channel: IChannel; initialGifs: IGif[] }

const ClipsGrid = ({ channel, initialGifs }: Props) => {
    const { deviceType } = useContext(UAParserContext)
    const getTrackingUrl = (page: number) => `/${channel.slug}/page/${page}`
    const fetchGifs = useCallback(
        async (offset: number) => {
            const result = await getChannelClipsByUsername(
                channel.user.username,
                { offset, limit: clientsideFetchLimit },
                document.cookie as string
            )
            return result
        },
        [channel.user.username]
    )
    return (
        <VideoGrid
            hideAttribution
            columns={deviceType === 'desktop' ? 3 : undefined}
            gridWidth={desktopContent}
            initialGifs={initialGifs}
            fetchGifs={fetchGifs}
            gaTrackingUrl={getTrackingUrl}
        />
    )
}

export default ClipsGrid
